<template>
  <div>
    <div class="level-two-title main-red-color bold-text mb-3">
      {{ $t(element.title) }}
    </div>

    <div class="d-flex flex-row justify-content-between my-2">
      <div class="bold-text main-color-text"> {{ $t('operation.bilan.PrixHT') }}</div>
      <div v-if="element.prixHT"> {{ Intl.NumberFormat().format(Math.round(element.prixHT)) + " €" }}</div>
      <div v-else> -</div>
    </div>

    <div class="d-flex flex-row justify-content-between my-2">
      <div class="bold-text main-color-text"> {{ $t('operation.bilan.TVA') }}</div>
      <div v-if="element.TVA"> {{ Intl.NumberFormat().format(Math.round(element.TVA)) + " €" }}</div>
      <div v-else> -</div>
    </div>

    <div class="d-flex flex-row justify-content-between my-2">
      <div class="bold-text main-color-text"> {{ $t('operation.bilan.PrixTTC') }}</div>
      <div v-if="element.prixTTC"> {{ Intl.NumberFormat().format(Math.round(element.prixTTC)) + " €" }}</div>
      <div v-else> -</div>
    </div>
  </div>

</template>

<script>
export default {
  name: "SectionCardPrice",

  props: {
    element: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanCreateEditSteps/components/SectionCardPrice.vue